import Version from './version';

export default (ua) => {
  if (ua.match(/Weibo/i)) {
    return {
      name: 'Weibo',
      isWeibo: true,
      version: new Version('0.0.0'),
    };
  }

  const matched = ua.match(/MicroMessenger\/([\d_.]+)/i);
  if (matched) {
    return {
      name: 'Weixin',
      isWeixin: true,
      version: new Version(matched[1].replace(/_/g, '.')),
    };
  }

  return false;
};
